import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShippingService } from '../../services/api-services/shipping.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-confirm-req-order',
  templateUrl: './confirm-req-order.component.html',
  styleUrl: './confirm-req-order.component.scss'
})
export class ConfirmReqOrderComponent {
  processLoading: boolean = false;
  sourceData: {};

  constructor(
    public dialogRef: MatDialogRef<ConfirmReqOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private shippingService: ShippingService,
    private toastr: ToastrService,
  ) {
    this.sourceData = {
      type: this.data.item || 'N/A',
      success: true
    };
  }

  confirmTransfer() {
    this.dialogRef.close(this.sourceData);
  }

  // Proceed to create sales order after all Rx IDs are added
  renew_refill_process_order() {
    if (this.processLoading) {
      return;
    }
    const payload = {
      "user_id": this.data.item.user_id,
      "server_location": this.data.item.server_location,
      "search_rx_values": this.data.item.search_rx_values,
      "sales_order_id": this.data.item.sales_order_id,
      "refill_request_ids": this.data.item.refill_request_ids,
      "type": this.data.item.type || ''
    }
    this.processLoading = true;
    this.shippingService.renew_refill_process_order(payload).subscribe({
      next: (res) => {
        if (res?.body?.success) {
          this.toastr.success(res?.body?.message || 'Refill process order renewed successfully');
          this.dialogRef.close(res?.body?.success);
        } else {
          this.toastr.error(res?.body?.message || 'Failed to renew refill process order');
          this.processLoading = false;
        }
      },
      error: (err) => {
        console.error('error::', err);
        this.toastr.error('something went wrong!');
        this.processLoading = false;
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
